import useSwr from 'swr';

import { Company, searchSchema } from '@/api/search/search-schema';
import { apiRoutes } from '@/utils/api-routes';
import { validateFetcher } from '@/utils/validateFetcher';

export const useSearchData = (expression: string) => {
  const { data, error } = useSwr<Company[]>(
    {
      endpoint: expression
        ? `${apiRoutes.searchUrl}?expression=${expression}`
        : apiRoutes.searchUrl,
      schema: searchSchema,
    },
    validateFetcher,
    {
      revalidateOnFocus: false,
    }
  );

  return {
    companies: data,
    loading: !data && !error,
    error,
  };
};
